<div>
  <AdminLogin v-if="!loggedIn" @logged-in="login()"> </AdminLogin>
  <div v-else class="user-feedback-page admin">
    <template v-if="document">
      <Annotator :document="document"
                 :feedbacks="feedbacks"
                 :person_id="'dont_need_this'"
                 ref="annotator"
                 v-model:active_feedback="active_feedback"
                 v-model:hover_feedback="hover_feedback">
      </Annotator>
      <section class="comments">
        <p v-if="num_comments > 0">
        {{num_comments}} comments from {{num_people}} people
        </p>
        <template v-for="feedback_item in feedbacks">
          <article role="button"
                   class="feedback-item"
                  :id="feedback_item.id"
                   :class="{hovered: active_feedback?.id  == feedback_item?.id}"
                   @mouseenter="hover_feedback = feedback_item"
                   @mouseleave="hover_feedback = undefined"
                   @click="active_feedback = feedback_item; $refs.annotator.scrollTo(feedback_item.id)">

            <span class="new" v-if="feedback_item.updated > document.last_viewed">New</span>
            <span role="img" v-html="icons[feedback_item.emoji].emoji"> </span>
            {{feedback_item.expand?.person_id?.name}}:
            {{feedback_item.content}}
          </article>
        </template>
      </section>
    </template>
  </div>
</div>
